// extracted by mini-css-extract-plugin
module.exports = {"question":"faq-module--question--7r06W","faq":"faq-module--faq--44F6m","image":"faq-module--image--6UMtt","answer":"faq-module--answer--4ifUD"};